<template>
    <div class="outer-content blur foreground">
        <div class="inner-content">
            <div class="calendar_box">
                <h2 class="calendar_title" v-html="T('calendar_next_round')"></h2>
                <DynamicImage id="calendar" class="calendar_gif"></DynamicImage>
                <AudioClip v-if="isMuted === false" :autoplay="true" id="Calendar-flip1" :overrideVolume="1">
                </AudioClip>
                <div class="calendar_body">
                    <p v-html="incomeText"></p>
                </div>
                <button class="btn-base calendar_BTN" @click="$emit('next-clicked')"
                    v-html="continueButtonText"></button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import DynamicImage from './DynamicImage.vue';
import { T, roundedValue } from '@/App.vue';
import Game from '../../../shared_fca/game';
import playerState from '../../../shared_fca/playerstate';
import AudioClip from './AudioClip.vue';

export default Vue.extend({
    name: 'CalendarPopUp',
    components: {
        DynamicImage,
        AudioClip
    },
    props: {
        game: Object as PropType<Game>,
        playerState: Object as PropType<playerState>,
        isMuted: Boolean,
    },
    computed: {

        continueButtonText: {
            cache: false,
            get(): string {
                return T("calendar_round_" + (this.playerState.round + 1));
            }
        },

        incomeText: {
            cache: false,
            get(): string {

                let displayString: string

                //'calendar_income';
                if (this.playerState.display_repair) {
                    if (this.playerState.display_rent) {
                        displayString = "calendar_income_rent_repairs";
                    }
                    else {
                        displayString = "calendar_income_repairs";
                    }
                }
                else {
                    if (this.playerState.display_rent) {
                        displayString = "calendar_income_rent";
                    }
                    else {
                        displayString = "calendar_income";
                    }
                }


                return T(displayString)
                    .replace('###', roundedValue(this.playerState.display_income))
                    .replace('&&&', roundedValue(this.playerState.display_rent))
                    .replace('$$$', roundedValue(this.playerState.display_repair))
                    .replace('%%%', roundedValue(this.playerState.bankBalance));
            }
        }
    },
    methods: {
        T(key: string): string {
            return T(key);
        }
    }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/*Calendar animation pop up*/
p {
    margin-left: 50px;
    margin-right: 50px;
}

.calendar_box {
    width: 752px;
    height: 571px;
    border-radius: 29px;
    background-color: #FFFFFF;
    position: absolute;
    top: 157px;
    left: 156px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.calendar_title {
    height: 36px;
    color: #007D8D;
    font-size: 30px;
    font-weight: 800;
    line-height: 36px;
    margin-top: 31px;
    left: 293px;
}

.calendar_gif {
    height: 302px;
    width: 340px;
    position: absolute;
    top: 96px;
}

.calendar_body {
    color: #333333;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    text-align: center;
    position: absolute;
    top: 432px;
}

.calendar_BTN {
    height: 50px;
    width: 162px;
    border-radius: 8px;
    background-color: #B2CD30;
    color: #FFFFFF;
    font-family: Rubik;
    font-size: 14px;
    font-weight: 800;
    line-height: 16.59px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    border: 0;
    position: absolute;
    top: 480px;
}
</style>